import Badge from "./badge";
import pure from "./higher-order/pure";
import React from "react";

var badgeProps = {
  classic: {
    color: "white",
    ghost: true,
    icon: "horseshoe-solid",
    text: "Classic Game"
  },
  featured: {
    color: "dark-lime",
    icon: "star",
    text: "Featured Game"
  },
  guaranteed: {
    color: "purple",
    icon: "checkmark4",
    text: "Guaranteed Game"
  },
  lockdown: {
    color: "orange",
    icon: "key",
    text: "Lockdown Game"
  },
  qualifier: {
    color: "copen-blue",
    icon: "award2",
    text: "Qualifier Game"
  },
  "real-money": {
    color: "lime",
    icon: "real-money",
    text: "Live Bankroll Game"
  },
  survivor: {
    color: "white",
    ghost: true,
    icon: "survivor",
    text: "Survivor Game"
  },
};

export default pure(function PredefinedBadge({ type }) {
  var badge = badgeProps[type];
  if (!badge) {
    return null;
  }
  return (
    <Badge {...badge} iconOnly />
  );
});
